module.exports = __webpack_public_path__ + "img/promote-your-music-on-instagram.648f7328.jpg";